import type {
  CreateWorkerInput,
  UpdateWorkerInput,
  WorkerDetail,
  WorkerFormOptions,
  WorkerImportResult,
  WorkerSummary,
} from "@crewledger/shared/schemas";
import { apiFetch, downloadAuthenticatedFile } from "@/lib/api";

export async function fetchWorkers(params?: {
  page?: number;
  pageSize?: number;
  siteId?: string;
  crew?: string;
  trade?: string;
  status?: string;
  q?: string;
}) {
  const search = new URLSearchParams();
  if (params?.page) search.set("page", String(params.page));
  if (params?.pageSize) search.set("pageSize", String(params.pageSize));
  if (params?.siteId) search.set("siteId", params.siteId);
  if (params?.crew) search.set("crew", params.crew);
  if (params?.trade) search.set("trade", params.trade);
  if (params?.status) search.set("status", params.status);
  if (params?.q) search.set("q", params.q);

  const qs = search.toString();
  return apiFetch<{ data: WorkerSummary[]; meta: { total?: number } }>(
    `/api/workers${qs ? `?${qs}` : ""}`,
  );
}

export async function fetchWorkerOptions() {
  return apiFetch<{ data: WorkerFormOptions }>("/api/workers/options");
}

export async function fetchWorker(workerId: string) {
  return apiFetch<{ data: WorkerDetail }>(`/api/workers/${workerId}`);
}

export async function createWorker(input: CreateWorkerInput) {
  return apiFetch<{ data: WorkerDetail }>("/api/workers", {
    method: "POST",
    body: JSON.stringify(input),
  });
}

export async function updateWorker(workerId: string, input: UpdateWorkerInput) {
  return apiFetch<{ data: WorkerDetail }>(`/api/workers/${workerId}`, {
    method: "PATCH",
    body: JSON.stringify(input),
  });
}

export async function deactivateWorker(workerId: string) {
  return apiFetch<{ data: WorkerDetail }>(`/api/workers/${workerId}/deactivate`, {
    method: "POST",
  });
}

export async function importWorkersCsv(csv: string) {
  return apiFetch<{ data: WorkerImportResult }>("/api/workers/import", {
    method: "POST",
    headers: { "Content-Type": "text/csv" },
    body: csv,
  });
}

export function downloadWorkerTemplate(): Promise<void> {
  return downloadAuthenticatedFile(
    "/api/workers/import/template",
    "werkio-worker-import-template.csv",
  );
}
